import { Index as Cards } from '@piconetworks/cards'
import withInjection from '@piconetworks/with-injection'

import Loader from 'common/modules/loader'
import Router from 'common/modules/router'
import WizardRedux, { WizardLoading } from 'common/pkgs/WizardRedux'

import { paymentMethods } from 'common/modules/selectors'

const mapStateToProps = (state, props) => {
    const {
        wizard: {
            wizards = {},
        } = {},
    } = state

    const {
        router: {
            query: {
                id: wizardName,
                short_code,
                resetWizard,
            },
        },
    } = props

    const cardWizardName = 'CardWizard'

    const {
        submit: {
            payload: {
                selectedPaymentMethod,
            } = {},
        } = {},
    } = wizards[cardWizardName] || {}

    const userVerified = Loader.selectors.userVerified(state)
    const currentPaymentMethods = paymentMethods(state)
    const wizardIsComplete = !resetWizard && (!!selectedPaymentMethod)

    return {
        ...props,
        cardWizardName,
        wizardIsComplete,
        wizard: state.wizard,
        submitActionType: Router.types.REPLACE,
        paymentMethods: !userVerified ? [] : currentPaymentMethods,
        submitPayload: {
            url: {
                pathname: '/cards',
                query: {
                    ...(wizardName && { id: wizardName }),
                    ...(short_code && { short_code }),
                },
            },
            as: {
                pathname: '/cards',
                query: {
                    ...(wizardName && { id: wizardName }),
                    ...(short_code && { short_code }),
                },
            },
        },
        WizardRedux,
        WizardLoading,
        userVerified,
    }
}

const InjectedCards = withInjection(Cards, {
    mapStateToProps,
})

export default InjectedCards
